export class AssocUser {
  id: number;
  user_id: number;
  assoc_id: number;
}